import * as React from "react";
import jfetch from "../../utils/jfetch";
import toast from "../../utils/toast";
import * as moment from 'moment';
import SearchTable from "../core/SearchTable";
import Panel from "../core/Panel";

interface IProps {
  course: any;
}

interface IState {
  courseUsers: any;
  selectedPage: number;
  totalPages: number;
  isLoading: boolean;
  selectedOption: any;
  searchValue: string;
}

const tableHeadings = ['Name', 'Title', 'Organization', '% Completed', 'Date Started'];

const pageNumOptions = [
  {value: 5, label: '5 Results'},
  {value: 10, label: '10 Results'},
  {value: 25, label: '25 Results'},
  {value: 50, label: '50 Results'},
  {value: 100, label: '100 Results'},
];

class CourseUsers extends React.Component<IProps, IState> {
  state: IState = {
    courseUsers: [],
    selectedPage: 0,
    totalPages: 1,
    isLoading: true,
    selectedOption: pageNumOptions[0],
    searchValue: '',
  };

  componentDidMount(): void {
    this.getUsers(1, this.state.selectedOption['value'], null);
  }

  async getUsers(page: number, per: number, searchTerm: string | null) {
    this.setState({isLoading: true});
    const url = `users/${page}/${per}` + (searchTerm ? `/${searchTerm}` : "");
    try {
      const users = await jfetch.get(url);
      if (users.data) {
        this.setState({
          courseUsers: users.data,
          totalPages: users.totalPages,
          isLoading: false,
        });
        return true;
      } else {
        return false;
      }
    } catch (e) {
      toast.error("Error retrieving course users");
    }
  }

  handlePageClick = (data) => {
    this.getUsers(data.selected + 1, this.state.selectedOption['value'], this.state.searchValue);
    this.setState({selectedPage: data.selected});
  };

  handleOptionChange = (selectedOption) => {
    if (selectedOption !== this.state.selectedOption) {
      this.getUsers(1, selectedOption['value'], this.state.searchValue);
    }
    this.setState({selectedOption});
  };

  handleSearch = (event) => {
    if (event.key === 'Enter') {
      this.setState({selectedPage: 0});
      this.getUsers(1, this.state.selectedOption['value'], this.state.searchValue);
    }
  };

  generateUserRows = (data) => {
    return (
      <tr key={data.id}>
        <td>{data.name}</td>
        <td>{data.job_title ? data.job_title : "No Title"}</td>
        <td>{data.title}</td>
        <td>{data.percent_complete + "%"}</td>
        <td>{moment(data.created_at).format('MM/DD/YYYY')}</td>
      </tr>
    );
  }

  render() {
    const {isLoading, courseUsers, totalPages, selectedPage, selectedOption} = this.state;
    return (
      <Panel heading={"Course Users"}>
        <SearchTable
          searchOnChange={(event) => this.setState({searchValue: event.target.value})}
          searchOnKeyDown={this.handleSearch}
          searchValue={this.state.searchValue}
          pagesSelectValue={selectedOption}
          pagesSelectOnChange={this.handleOptionChange}
          loading={isLoading}
          data={courseUsers}
          rowDataCallback={this.generateUserRows}
          totalPages={totalPages}
          selectedPage={selectedPage}
          onPageChange={this.handlePageClick}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          pageNumOptions={pageNumOptions}
          tableHeadings={tableHeadings}
        />
      </Panel>
    );
  }
}

export default CourseUsers;



// WEBPACK FOOTER //
// ./app/javascript/components/report/CourseUsers.tsx